import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { verification } from '../api';
import { useAuth } from '../context/AuthContext';

type Status = 'verifying' | 'success' | 'error';

export default function VerifyEmailPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const { user, refresh } = useAuth();
  const [status, setStatus] = useState<Status>('verifying');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      return;
    }
    verification
      .verify(token)
      .then(async () => {
        if (user) await refresh();
        setStatus('success');
      })
      .catch(() => setStatus('error'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-8 text-center space-y-4">
        <h1 className="text-2xl font-bold text-slate-900">{t('verify.title')}</h1>
        {status === 'verifying' && <p className="text-slate-600">{t('verify.working')}</p>}
        {status === 'success' && (
          <>
            <p className="text-green-700">{t('verify.success')}</p>
            <Link
              to={user ? '/dashboard' : '/login'}
              className="inline-block bg-slate-900 text-white rounded px-4 py-2 hover:bg-slate-800"
            >
              {user ? t('verify.continueToDashboard') : t('verify.continueToLogin')}
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="text-red-700">{t('verify.error')}</p>
            <Link to="/" className="inline-block text-slate-600 hover:underline">
              {t('common.backHome')}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
